import {
  laptopMediumMax,
  laptopMediumMin,
  largeTabletMax,
  tabletMax,
} from '@propertypal/shared/src/constants/mediaQueries';
import Link from 'next/link';
import styled, { css } from 'styled-components';
import { Container as FavouriteContainer } from '../property-box/PropertyFavourite.style';
import { Heading } from '../typography';

export const Container = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 30px;

  @media (${largeTabletMax}) {
    flex-direction: column;
  }
`;

export const SummaryBox = styled.div`
  position: relative;
  padding-right: 20px;
  flex: 1;

  // Allows custom colour on favourite icon
  button {
    color: inherit;
  }

  @media (${largeTabletMax}) {
    padding: 0;
    width: 100%;
  }
`;

export const TopBox = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  flex-flow: wrap-reverse;

  @media (${laptopMediumMin}) {
    align-items: center;
  }

  @media (${laptopMediumMax}) {
    flex-direction: column-reverse;
  }
`;

export const Badges = styled.div`
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
`;

export const Badge = styled.div<{ blue?: boolean }>`
  background-color: ${({ theme, blue }) => (blue ? `#30bced` : theme.primary)};
  color: ${({ theme }) => theme.white};
  font-weight: 600;
  font-size: 15px;
  padding: 2px 6px;
  border-radius: 5px;
  align-content: center;
`;

const IconStyle = css`
  span,
  svg {
    font-size: 17px;
    transition: color 150ms linear;
  }

  &:hover {
    span,
    svg {
      color: ${({ theme }) => theme.primary};
    }
  }
`;

export const ActionsContainer = styled.div`
  display: flex;
  row-gap: 10px;
  column-gap: 20px;

  @media (${laptopMediumMax}) {
    margin-bottom: 20px;
    flex-wrap: wrap;
    column-gap: 10px;
    row-gap: 0px;
  }

  ${FavouriteContainer} {
    ${IconStyle}
  }
`;

export const IconLink = styled(Link)`
  display: flex;
  align-items: center;

  span {
    font-size: 14px;
    color: ${({ theme }) => theme.textDark};
  }

  ${IconStyle}
`;

export const IconContainer = styled(FavouriteContainer)`
  ${IconStyle}
`;

export const AddressHeader = styled(Heading)`
  @media (${tabletMax}) {
    font-size: 25px;
  }
`;
